import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  AccreditationQuery as AccreditationQueryType,
  AccreditationQueryVariables,
} from "./__generated__/AccreditationQuery";

const AccreditationQuery = loader("./AccreditationQuery.gql");

type AccreditationQueryProviderType = (props: {
  children: (data: AccreditationQueryType) => ReactNode;
  variables: AccreditationQueryVariables;
}) => ReactElement;

export const AccreditationQueryProvider: AccreditationQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<AccreditationQueryType, AccreditationQueryVariables>(AccreditationQuery, {
    variables,
    fetchPolicy: "no-cache",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
